import { Injectable } from "@nestjs/common";
import { Grn } from "../grn/grn.entity";
import { GrnItemReturns } from "./grn-item-return-entity";
import { GrnDetailsForReturn } from "./dto/grn-detail-for-return.dto";
import { GrnReturns } from "./grn-return-entity";

@Injectable()
export class GrnReturnAdapter {
    public convertDtoToEntity(grnReturnDto: GrnDetailsForReturn): GrnReturns {
        const grnRtn = new GrnReturns();
        grnRtn.grnReturnDate = grnReturnDto.grnReturnDate;
        grnRtn.grnReturnNumber = grnReturnDto.grnReturnNumber;
        grnRtn.remarks = grnReturnDto.remarks;
        grnRtn.grnId = new Grn();
        grnRtn.grnId.grnId = grnReturnDto.grnId;
        grnRtn.createdUser = grnReturnDto.createdUser;
        grnRtn.plantId = grnReturnDto.plantId;
        const grnReturnItems: GrnItemReturns[] = []
        for (const grnReturnItemData of grnReturnDto.grnItems) {
            const grnReturnItem = new GrnItemReturns();
            grnReturnItem.itemCategoryId = grnReturnItemData.itemCategoryId;
            grnReturnItem.itemSubCategoryId = grnReturnItemData.itemSubCategoryId;
            grnReturnItem.itemId = grnReturnItemData.itemId;
            grnReturnItem.sizeId = grnReturnItemData.sizeId;
            grnReturnItem.availableQty = grnReturnItemData.availQty;
            grnReturnItem.unitPrice = grnReturnItemData.unitPrice;
            grnReturnItem.grnTotalReturnPrice = grnReturnItemData.grnTotalReturnPrice;
            grnReturnItem.grnReceiveQty = grnReturnItemData.grnReceivedQty;
            grnReturnItem.grnReturnQty = grnReturnItemData.grnReturnQty;
            grnReturnItem.grnItemId = grnReturnItemData.grnItemId;
            grnReturnItem.grnId = grnReturnDto.grnId;
            grnReturnItem.createdUser = grnReturnDto.createdUser;
            grnReturnItem.stockId = grnReturnItemData.stockId;
            grnReturnItem.discountPercentage = grnReturnItemData.discountPercentage;
            grnReturnItem.discountAmount = grnReturnItemData.discountAmount;
            grnReturnItem.taxPercentage = grnReturnItemData.taxPercentage;
            grnReturnItem.taxAmount = grnReturnItemData.taxAmount;
            grnReturnItem.remarks = grnReturnItemData.remarks;
            grnReturnItems.push(grnReturnItem);
        }
        grnRtn.grnReturnItemsInfo = grnReturnItems;
        return grnRtn;
    }
}